export default __webpack_public_path__ + "static/media/Sefcon-500-eng.8c0a3f27.jpg";